import mutations from './drugStrain.mutations'
import actions from './drugStrain.actions'
import getters from './drugStrain.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
